import { Badge } from "@circleco/compass/components/Badge";
import type { BadgeProps } from "@circleco/compass/components/Badge";

import { t } from "@/i18n-js/instance";

import { UpgradeFigureSkeleton } from "./UpgradeLoadingSkeletons";

const i18nRoot = "paywall_checkout.offer_page.upgrade";

export const UpgradeTargetTrialBadge = ({
  days,
  testId = "upgrade-target-trial-badge",
  variant = "carolinaBlue",
}: {
  days?: number | null;
  testId?: string;
  variant?: BadgeProps["variant"];
}) => {
  if (!days || days < 1) return null;

  return (
    <Badge
      data-testid={testId}
      label={t([i18nRoot, "target_trial_badge"], { count: days })}
      variant={variant}
    />
  );
};

export const UpgradePriceBadges = ({
  couponLabel,
  trialDays,
  isRefreshing,
}: {
  couponLabel?: string;
  trialDays?: number | null;
  isRefreshing: boolean;
}) => {
  const hasTrial = !isRefreshing && Boolean(trialDays && trialDays > 0);
  if (!couponLabel && !hasTrial) return null;

  return (
    <div className="flex shrink-0 flex-wrap items-center gap-2">
      {hasTrial && <UpgradeTargetTrialBadge days={trialDays} />}
      {couponLabel &&
        (isRefreshing ? (
          <UpgradeFigureSkeleton className="h-6 w-20" />
        ) : (
          <Badge
            label={couponLabel}
            variant="success"
            data-testid="upgrade-percent-off-today"
          />
        ))}
    </div>
  );
};
